import { t } from "i18next";

import { useSelectedDealer } from "components";
import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { DEALER_REPORT_COLUMNSS, REPORT_COLUMN_TYPES } from "models";
import { useThresholdSettingsListeners } from "modules/DealerOverviewDashboard/components/DmsSystem/components/ThresholdSettings/listeners";
import { DealerOverviewDashboardQueryKeys } from "modules/DealerOverviewDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { enumToDropdownOptions } from "utils/common";

import type { DealerReportThreshold } from "models";

export type DefaultReportThreshold = Pick<DealerReportThreshold, "dealer_report_column" | "low_value" | "high_value" | "report_column_type">;

const reportColumns = enumToDropdownOptions({ enumObj: DEALER_REPORT_COLUMNSS, t }).map(({ value }) => value);
const defaultReportThresholds: DefaultReportThreshold[] = reportColumns.map(dealer_report_column => ({
  dealer_report_column,
  low_value: null,
  high_value: null,
  report_column_type: REPORT_COLUMN_TYPES.Number
}));

const mergeWithDefaults = (thresholds: DealerReportThreshold[]) =>
  defaultReportThresholds.map(dTr => thresholds.find(tr => tr.dealer_report_column === dTr.dealer_report_column) ?? dTr);

export const useListThresholdsQuery = () => {
  const { selectedDealer } = useSelectedDealer();
  const listeners = useThresholdSettingsListeners(selectedDealer?.id);

  return useRealTimeTypedQuery({
    queryKey: DealerOverviewDashboardQueryKeys.thresholds(selectedDealer?.id),
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { dealer_id: selectedDealer?.id }, baseUrl)).data?.dealer_report_thresholds ?? [],
    select: mergeWithDefaults,
    enabled: Boolean(selectedDealer?.id),
    listeners
  });
};
